import React, { useCallback, useContext, useEffect, useState } from "react";

import { Button, Card, H5 } from "@blueprintjs/core";
import ReactJson from "react-json-view";
import Splitter from "components/Splitter";
import ProjectMenu from "components/projects/ProjectMenu";

import ScheduleGrid from "components/projects/schedules/ScheduleGrid";
import ScheduleDialog from "components/projects/schedules/ScheduleDialog";
import { ScheduleDoc } from "types";
import { SelectedProjectContext } from "utils/context";

export default function SchedulePage() {
    const [schedule, setSchedule] = useState<ScheduleDoc>();
    const [isOpen, setIsOpen] = useState(false);
    const [editing, setEditing] = useState(false);
    const [cloning, setCloning] = useState(false);
    const project = useContext(SelectedProjectContext);

    const toggle = useCallback(() => {
        setIsOpen(!isOpen);
    }, [isOpen]);

    const clearEditAndClone = useCallback(() => {
        setEditing(false);
        setCloning(false);
    }, []);

    useEffect(() => {
        setSchedule(undefined);
    }, [project]);
    return (
        <div className="main-container">
            <ScheduleDialog
                isOpen={isOpen}
                toggle={toggle}
                editing={editing}
                cloning={cloning}
                schedule={schedule}
                clearEditAndClone={clearEditAndClone}
            />
            <ProjectMenu
                page="schedules"
                actions={[<Button key="new-schedule" icon="new-object" text="New" intent="primary" onClick={toggle} />]}
            />
            <div className="splitter-container">
                <Splitter
                    primaryFraction={45}
                    primary={
                        <div className="grid-container">
                            <div className="ag-theme-balham-dark ag">
                                <ScheduleGrid
                                    setSchedule={setSchedule}
                                    setEditing={setEditing}
                                    setCloning={setCloning}
                                    toggle={toggle}
                                />
                            </div>
                        </div>
                    }
                    secondary={
                        <div className="secondary-card">
                            <Card className="json-viewer">
                                <H5 className="json-header">
                                    {schedule ? schedule.schedule.schedName : "Please Select a Schedule to View"}
                                </H5>
                                {schedule && (
                                    <ReactJson
                                        name="job"
                                        src={schedule}
                                        style={{
                                            textAlign: "left",
                                            fontSize: "1rem",
                                            wordBreak: "break-all"
                                        }}
                                        displayDataTypes={false}
                                        displayObjectSize={false}
                                        // enableClipboard={false}
                                        theme="ashes"
                                        iconStyle="square"
                                    />
                                )}
                            </Card>
                        </div>
                    }
                />
            </div>
        </div>
    );
}
